import { SagaIterator } from 'redux-saga'
import { takeEvery, call } from 'redux-saga/effects'
import { Action } from 'typescript-fsa'
import { RedeemCode } from 'mytours-read-api-typescript'

import { AppMetaData } from '../api/types'
import { loadedMetaDataComplete } from '../settings/actions'
import { validateOwnedCollection } from '../api/actions'
import { removeRevokedCodeFromDisk, removeRejectedCodeFromDisk, revalidatePersistedCodes } from '../api/sagas'

/**
 * Rebuild the collection-ownership slice from the persisted disk codes whenever metadata becomes
 * available (boot — disk or network — and every periodic checkForUpdates sync). The slice is wiped
 * on reload (blacklisted from redux-offline), so this repopulates it; revalidation drops
 * revoked/expired codes (removeRevokedCodeFromDisk). The collection analog of
 * handleMetaDataReadyForBundles.
 */
function* handleMetaDataReadyForCollections(action: Action<AppMetaData>): SagaIterator {
	if (!action.payload) {
		return
	}
	yield call(revalidatePersistedCodes, RedeemCode.LinkedTypeEnum.Collection, validateOwnedCollection)
}

export default function* (): SagaIterator {
	yield takeEvery(validateOwnedCollection.done, removeRevokedCodeFromDisk, RedeemCode.LinkedTypeEnum.Collection)
	yield takeEvery(validateOwnedCollection.failed, removeRejectedCodeFromDisk, RedeemCode.LinkedTypeEnum.Collection)
	yield takeEvery(loadedMetaDataComplete, handleMetaDataReadyForCollections)
}
